
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbTypeahead } from "@commonNodeModules/@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@commonNodeModules/@ngx-translate/core";
import { SearchHighLightPipe } from "@commonPipes/searchHightlight";
import { Observable, Subject, merge } from "rxjs";
import { distinctUntilChanged, filter, switchMap } from "rxjs/operators";

@Component({
	selector: "app-simple-searchbar",
	templateUrl: "./simple-searchbar.component.html",
	styleUrls: ["./simple-searchbar.component.scss"],
	imports: [FormsModule, NgbTypeahead, TranslatePipe, SearchHighLightPipe]
})
export class SimpleSearchbarComponent implements OnInit, OnDestroy {
	constructor() { }
	@Input() searchValue: string;
	@Input() searchValues: string[];
	@Output() search = new EventEmitter();
	@ViewChild('instance') instance: NgbTypeahead;
	public click = new Subject<string>();

	ngOnInit() { }

	ngOnDestroy(): void {
		this.click?.unsubscribe();
	}

	private getValues(term: string) {
		if (term === "") {
			return [];
		}
		return this.searchValues?.filter(f => f.toUpperCase().startsWith(term.toUpperCase()));
	}

	public selectItem(input) {
		this.search.emit(input.item);
	}

	public clearImput() {
		this.searchValue = "";
		this.search.emit("");
	}

	public searchField = (text: Observable<string>) => {
		const debouncedText = text.pipe(distinctUntilChanged());
		const clicksWithClosedPopup = this.click.pipe(filter(() => !this.instance.isPopupOpen()));
		return merge(debouncedText, clicksWithClosedPopup).pipe(
			switchMap(async term => {
				this.search.emit(term);
				return this.getValues(term);
			})
		);
	}
}